import React from "react";
import { useTranslation } from "react-i18next";
import { BiBrush } from "react-icons/bi";

const MarkdownHelpModal = () => {
  const { t } = useTranslation();

  return (
    <div className="markdown-help-modal tw-p-6 tw-max-w-3xl tw-mx-auto">
      <h1 className="tw-text-2xl tw-font-bold tw-mb-6 tw-text-center">
        <BiBrush className="tw-mr-2" size={40} color="blue" />{" "}
        {t("Markdown/guide")}
      </h1>
      <h2 className="tw-text-xl tw-font-semibold tw-mb-2 tw-text-center">
        {t("Markdown/guide2")}
      </h2>

      <p className="tw-mb-4">{t("Markdown/welcome")}</p>

      <h2 className="tw-text-xl tw-font-semibold tw-mb-2 tw-text-center">
        {t("Markdown/whatis")}
      </h2>
      <p className="tw-mb-4">{t("Markdown/desc")}</p>

      <h2 className="tw-text-xl tw-font-semibold tw-mb-2 tw-text-center">
        {t("Markdown/basic")}
      </h2>

      <h3 className="tw-text-lg tw-font-medium tw-mb-2 tw-text-center">
        <u>{t("Markdown/style")}</u>
      </h3>
      <div className="tw-overflow-x-auto tw-mb-4">
        <table className="tw-min-w-full tw-border tw-border-gray-300">
          <thead>
            <tr className="tw-bg-gray-100">
              <th className="tw-border tw-border-gray-300 tw-p-2">
                {t("Markdown/whattype")}
              </th>
              <th className="tw-border tw-border-gray-300 tw-p-2">
                {t("Markdown/whatsee")}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="tw-border tw-border-gray-300 tw-p-2 tw-font-mono">
                **{t("Markdown/bold")}**
              </td>
              <td className="tw-border tw-border-gray-300 tw-p-2 tw-font-bold">
                {t("Markdown/bold")}
              </td>
            </tr>
            <tr>
              <td className="tw-border tw-border-gray-300 tw-p-2 tw-font-mono">
                *{t("Markdown/italic")}* {t("Markdown/or")} _
                {t("Markdown/italic")}_
              </td>
              <td className="tw-border tw-border-gray-300 tw-p-2 tw-italic">
                {t("Markdown/italic")}
              </td>
            </tr>
            <tr>
              <td className="tw-border tw-border-gray-300 tw-p-2 tw-font-mono">
                ~~{t("Markdown/strikethrough")}~~
              </td>
              <td className="tw-border tw-border-gray-300 tw-p-2 tw-line-through">
                {t("Markdown/strikethrough")}
              </td>
            </tr>
            <tr>
              <td className="tw-border tw-border-gray-300 tw-p-2 tw-font-mono">
                **_{t("Markdown/bolditalic")}_**
              </td>
              <td className="tw-border tw-border-gray-300 tw-p-2 tw-font-bold tw-italic">
                {t("Markdown/bolditalic")}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3 className="tw-text-lg tw-font-medium tw-mb-2 tw-text-center">
        <u>{t("Markdown/headers")}</u>
      </h3>
      <div className="tw-bg-gray-100 tw-p-3 tw-rounded tw-font-mono tw-mb-2">
        <div># {t("Markdown/heading1")}</div>
        <div>## {t("Markdown/heading2")}</div>
        <div>### {t("Markdown/heading3")}</div>
        <div>#### {t("Markdown/heading4")}</div>
        <div>##### {t("Markdown/heading5")}</div>
        <div>###### {t("Markdown/heading6")}</div>
      </div>

      <div className="tw-mb-4 tw-text-gray-600">
        <p className="tw-font-medium">{t("Markdown/result")}:</p>
        <h1 className="tw-text-3xl tw-font-bold">{t("Markdown/heading1")}</h1>
        <h2 className="tw-text-2xl tw-font-bold">{t("Markdown/heading2")}</h2>
        <h3 className="tw-text-xl tw-font-bold ">{t("Markdown/heading3")}</h3>
        <h4 className="tw-text-lg tw-font-bold">{t("Markdown/heading4")}</h4>
        <h5 className="tw-text-sm">{t("Markdown/heading5")}</h5>
        <h6 className="tw-text-xs">{t("Markdown/heading6")}</h6>
      </div>

      <h3 className="tw-text-lg tw-font-medium tw-mb-2 tw-text-center">
        <u>{t("Markdown/links")}</u>
      </h3>
      <div className="tw-bg-gray-100 tw-p-3 tw-rounded tw-font-mono tw-mb-2">
        [{t("Markdown/linktext")}](https://www.example.com)
      </div>
      <div className="tw-mb-4">
        <p className="tw-font-medium">{t("Markdown/result")}:</p>
        <a href="#" className="tw-text-primary tw-underline">
          {t("Markdown/linktext")}
        </a>
      </div>

      <h3 className="tw-text-lg tw-font-medium tw-mb-2 <u>">
        <u>{t("Markdown/lists")}</u>
      </h3>

      <h4 className="tw-font-medium tw-mb-2">{t("Markdown/unorderedlists")}</h4>
      <div className="tw-bg-gray-100 tw-p-3 tw-rounded tw-font-mono tw-mb-2">
        <div>- {t("Markdown/item1")}</div>
        <div>- {t("Markdown/item2")}</div>
        <div>&nbsp;&nbsp;- {t("Markdown/subitem1")}</div>
        <div>&nbsp;&nbsp;- {t("Markdown/subitem2")}</div>
        <div>- {t("Markdown/item3")}</div>
      </div>
      <div className="tw-mb-4">
        <p className="tw-font-medium">{t("Markdown/result")}:</p>
        <ul className="tw-list-disc tw-pl-5">
          <li>{t("Markdown/item1")}</li>
          <li>
            {t("Markdown/item2")}
            <ul className="tw-list-disc tw-pl-5">
              <li>{t("Markdown/subitem1")}</li>
              <li>{t("Markdown/subitem2")}</li>
            </ul>
          </li>
          <li>{t("Markdown/item3")}</li>
        </ul>
      </div>

      <h4 className="tw-font-medium tw-mb-2">{t("Markdown/orderedlists")}</h4>
      <div className="tw-bg-gray-100 tw-p-3 tw-rounded tw-font-mono tw-mb-2">
        <div>1. {t("Markdown/firstitem")}</div>
        <div>2. {t("Markdown/seconditem")}</div>
        <div>3. {t("Markdown/thirditem")}</div>
      </div>
      <div className="tw-mb-4">
        <p className="tw-font-medium">{t("Markdown/result")}:</p>
        <ol className="tw-list-decimal tw-pl-5">
          <li>{t("Markdown/firstitem")}</li>
          <li>{t("Markdown/seconditem")}</li>
          <li>{t("Markdown/thirditem")}</li>
        </ol>
      </div>

      <h3 className="tw-text-lg tw-font-medium tw-mb-2 tw-text-center">
        <u>{t("Markdown/blockquotes")}</u>
      </h3>
      <div className="tw-bg-gray-100 tw-p-3 tw-rounded tw-font-mono tw-mb-2">
        <div>&gt; {t("Markdown/blockquote1")}</div>
        <div>&gt; {t("Markdown/blockquote2")}</div>
        <div>&gt;</div>
        <div>&gt; {t("Markdown/blockquote3")}</div>
      </div>
      <div className="tw-mb-4">
        <p className="tw-font-medium">{t("Markdown/result")}:</p>
        <blockquote className="tw-border-l-4 tw-border-gray-300 tw-pl-4 tw-italic">
          <p>
            {t("Markdown/blockquote1")}
            <br />
            {t("Markdown/blockquote2")}
          </p>
          <p>{t("Markdown/blockquote3")}</p>
        </blockquote>
      </div>

      <h3 className="tw-text-lg tw-font-medium tw-mb-2 tw-text-center">
        <u>{t("Markdown/code")}</u>
      </h3>

      <h4 className="tw-font-medium tw-mb-2">{t("Markdown/inlinecode")}</h4>
      <div className="tw-bg-gray-100 tw-p-3 tw-rounded tw-font-mono tw-mb-2">
        {t("Markdown/use")} `code` {t("Markdown/inyourtext")}
      </div>
      <div className="tw-mb-4">
        <p className="tw-font-medium">{t("Markdown/result")}:</p>
        <p>
          {t("Markdown/use")}{" "}
          <code className="tw-bg-gray-100 tw-px-1 tw-py-0.5 tw-rounded">
            code
          </code>{" "}
          {t("Markdown/inyourtext")}
        </p>
      </div>

      <h4 className="tw-font-medium tw-mb-2">{t("Markdown/codeblocks")}</h4>
      <div className="tw-bg-gray-100 tw-p-3 tw-rounded tw-font-mono tw-mb-2">
        ```
        <br />
        function example() &#123;
        <br />
        &nbsp;&nbsp;return "Hello world!";
        <br />
        &#125;
        <br />
        ```
      </div>
      <div className="tw-mb-4">
        <p className="tw-font-medium">{t("Markdown/result")}:</p>
        <pre className="tw-bg-gray-100 tw-p-3 tw-rounded">
          <code>
            function example() &#123;
            <br />
            &nbsp;&nbsp;return "Hello world!";
            <br />
            &#125;
          </code>
        </pre>
      </div>

      <h3 className="tw-text-lg tw-font-medium tw-mb-2 tw-text-center">
        <u>{t("Markdown/horizontalrules")}</u>
      </h3>
      <div className="tw-bg-gray-100 tw-p-3 tw-rounded tw-font-mono tw-mb-2">
        ---
      </div>
      <div className="tw-mb-4">
        <p className="tw-font-medium">{t("Markdown/result")}:</p>
        <hr className="tw-my-2" />
      </div>

      <h3 className="tw-text-lg tw-font-medium tw-mb-2 tw-text-center">
        <u>{t("Markdown/tables")}</u>
      </h3>
      <div className="tw-bg-gray-100 tw-p-3 tw-rounded tw-font-mono tw-mb-2 tw-overflow-x-auto">
        <div>
          | {t("Markdown/header1")} | {t("Markdown/header2")} |{" "}
          {t("Markdown/header3")} |
        </div>
        <div>|----------|----------|----------|</div>
        <div>
          | {t("Markdown/cell1")} | {t("Markdown/cell2")} |{" "}
          {t("Markdown/cell3")} |
        </div>
        <div>
          | {t("Markdown/cell4")} | {t("Markdown/cell5")} |{" "}
          {t("Markdown/cell6")} |
        </div>
      </div>
      <div className="tw-mb-4">
        <p className="tw-font-medium">{t("Markdown/result")}:</p>
        <div className="tw-overflow-x-auto">
          <table className="tw-min-w-full tw-border tw-border-gray-300">
            <thead>
              <tr className="tw-bg-gray-100">
                <th className="tw-border tw-border-gray-300 tw-p-2">
                  {t("Markdown/header1")}
                </th>
                <th className="tw-border tw-border-gray-300 tw-p-2">
                  {t("Markdown/header2")}
                </th>
                <th className="tw-border tw-border-gray-300 tw-p-2">
                  {t("Markdown/header3")}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="tw-border tw-border-gray-300 tw-p-2">
                  {t("Markdown/cell1")}
                </td>
                <td className="tw-border tw-border-gray-300 tw-p-2">
                  {t("Markdown/cell2")}
                </td>
                <td className="tw-border tw-border-gray-300 tw-p-2">
                  {t("Markdown/cell3")}
                </td>
              </tr>
              <tr>
                <td className="tw-border tw-border-gray-300 tw-p-2">
                  {t("Markdown/cell4")}
                </td>
                <td className="tw-border tw-border-gray-300 tw-p-2">
                  {t("Markdown/cell5")}
                </td>
                <td className="tw-border tw-border-gray-300 tw-p-2">
                  {t("Markdown/cell6")}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <h3 className="tw-text-lg tw-font-medium tw-mb-2 tw-text-center">
        <u>{t("Markdown/tasklists")}</u>
      </h3>
      <div className="tw-bg-gray-100 tw-p-3 tw-rounded tw-font-mono tw-mb-2">
        <div>- [x] {t("Markdown/completedtask")}</div>
        <div>- [ ] {t("Markdown/incompletetask")}</div>
        <div>- [ ] {t("Markdown/anothertask")}</div>
      </div>
      <div className="tw-mb-4">
        <p className="tw-font-medium">{t("Markdown/result")}:</p>
        <div>
          <div className="tw-flex tw-items-center tw-gap-2">
            <input type="checkbox" checked readOnly className="tw-h-4 tw-w-4" />
            <span>{t("Markdown/completedtask")}</span>
          </div>
          <div className="tw-flex tw-items-center tw-gap-2">
            <input type="checkbox" readOnly className="tw-h-4 tw-w-4" />
            <span>{t("Markdown/incompletetask")}</span>
          </div>
          <div className="tw-flex tw-items-center tw-gap-2">
            <input type="checkbox" readOnly className="tw-h-4 tw-w-4" />
            <span>{t("Markdown/anothertask")}</span>
          </div>
        </div>
      </div>

      <h2 className="tw-text-xl tw-font-semibold tw-mb-2 tw-text-center">
        {t("Markdown/tips")}
      </h2>
      <ol className="tw-list-decimal tw-pl-5 tw-mb-4">
        <li>
          <span className="tw-font-medium">{t("Markdown/spacing")}:</span>{" "}
          {t("Markdown/spacingdesc")}
        </li>
        <li>
          <span className="tw-font-medium">{t("Markdown/nesting")}:</span>{" "}
          {t("Markdown/nestingdesc")}
        </li>
        <li>
          <span className="tw-font-medium">{t("Markdown/escaping")}:</span>{" "}
          {t("Markdown/escapingdesc")}
        </li>
      </ol>

      <p className="tw-mb-4">{t("Markdown/escapingexample")}</p>

      <p className="tw-font-medium">{t("Markdown/conclusion")}</p>
    </div>
  );
};

export default MarkdownHelpModal;
